<div style="border: 1px solid red">fbos-contacts Component</div>
